module.exports = __webpack_public_path__ + "img/20191031163347232.d7eeacf9.jpg";